import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import dompurify from 'dompurify';
import ContentLandingPageWrapper from '../Components/ContentLandingPageWrapper';
import Fonts from '../Styles/Fonts';

const GeneralContent = styled.div`
    ${Fonts.blocks.generalContent};
`;

class EventInfoOverviewPage extends Component {
  componentDidMount = () => {
  };

  getSanitizedContent = () => {
      if (this.props.content && this.props.content.content) {
        return { __html: dompurify.sanitize(this.props.content.content) };
      } else {
          return { __html: "" };
      }
  };

  render() {
    return (
      <ContentLandingPageWrapper headerTitle="Event Info" headerSubtitle="Overview" fullWidth={true}>
        <GeneralContent dangerouslySetInnerHTML={ this.getSanitizedContent() }></GeneralContent>
      </ContentLandingPageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      content: state.content.eventInfoOverviewContent
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventInfoOverviewPage);